import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// 🔥 Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyBgxjAKNaYzbknHitG24Ln8R_sZ7zHVWrM",
  authDomain: "tifsu-ordering.firebaseapp.com",
  projectId: "tifsu-ordering",
  storageBucket: "tifsu-ordering.firebasestorage.app",
  messagingSenderId: "57334755491",
  appId: "1:57334755491:web:1a0449cb975dd242790f16",
};

// 🔥 Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { app, db, auth, googleProvider };
